import React from "react";
import { Paper, Stack, Group, Text, ThemeIcon, Title } from "@mantine/core";
import { useElementSize } from "@mantine/hooks";
import Confetti from "react-confetti";
import { IconCheck, IconBolt } from "@tabler/icons-react";

interface PaidNotificationDesignProps {
  title: string;
  satoshis: number;
  fiat: string;
  onClick: () => void;
}

const PaidNotificationDesign = ({
  title,
  satoshis,
  fiat,
  onClick,
}: PaidNotificationDesignProps) => {
  const { ref, width, height } = useElementSize();

  return (
    <Paper
      ref={ref}
      p={32}
      radius="md"
      shadow="md"
      onClick={onClick}
      style={{ background: "#000", position: "relative", cursor: "pointer" }}
    >
      <Confetti
        width={width}
        height={height}
        numberOfPieces={350}
        recycle={false}
      />

      <Stack align="center" gap={16}>
        <ThemeIcon radius="xl" size={160} style={{ background: "transparent" }}>
          <IconCheck color="green" size={160} stroke={4} />
        </ThemeIcon>

        <Title order={2} c="white">
          {title}
        </Title>

        <Group gap={6}>
          <IconBolt size={28} color="#FFD700" />
          <Text size="xl" fw={700} c="white">
            {satoshis.toLocaleString()}
          </Text>
        </Group>

        <Text size="lg" c="gray.4">
          {fiat}
        </Text>

        <Text size="sm" c="gray.5" mt={24}>
          Tap anywhere to continue
        </Text>
      </Stack>
    </Paper>
  );
};

export default PaidNotificationDesign;
